





















import { JournalEntry } from "../../models/JournalEntry";
import { Intervention } from "../../models/Intervention";
import EEtat = Intervention.EEtat;

export default {
    name: "InterventionsCount",
    props: {
        entry: JournalEntry,
    },
    computed: {
        cssClass: function () {
            if (this.entry.pending_interventions.length > 0) {
                let first_intervention = _.first(
                    this.entry.pending_interventions
                );
                if (first_intervention.isLate) {
                    return "btn-danger";
                } else if (first_intervention.etat === EEtat.Ongoing) {
                    return "btn-warning";
                } else {
                    return "btn-default";
                }
            }
        },
    },
};
